import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from './auth/auth.service';
import { AuthModule, OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthGuardService } from './auth/auth-guard.service';
import { JwtModule } from "@auth0/angular-jwt";
import { RoleGuardService } from './auth/role-guard.service';
import { CustomErrorHandler } from './custom-error-handler';
import { RequestIntegrity } from './request-integrety';

export function tokenGetter() {
  return localStorage.getItem("API_ACCESS_TOKEN");
}

@NgModule({
  imports: [
    CommonModule,
    AuthModule.forRoot({}),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: ["example.com"],
        disallowedRoutes: ["http://example.com/examplebadroute/"],
      },
    }),
  ],
  declarations: [],
  providers: [
    AuthService,
    OidcSecurityService,
    AuthGuardService,
    RoleGuardService,
    CustomErrorHandler,
    RequestIntegrity
  ]
})
export class CoreModule { }
